const main = () => {
  /* eslint-disable */
    var ajaxLock = false;
    //ajaxLock is just a flag to prevent double clicks and spamming
    function ajax_lazy_popup(postID) {

        ajaxLock = true;

        //Change that to your right site url unless you've already set global ajaxURL
        //Parameters you want to pass to query
        var ajaxdata = '?post_id=' + postID + '&action=ajax_lazy_popup';
        //Ajax call itself
        jQuery.ajax({

            type: 'get',
            url: ajaxurl + ajaxdata,
            dataType: 'json',

            //Ajax call is successful
            success: function (response) {
                //Add new posts
                if($('div.popup[data-popup="' + postID + '"]').length) {

                    $('.popup').hide();
                    $('div.popup[data-popup="' + postID + '"]').fadeIn(200);
                }
                else {

                    $('main').prepend('<div class="popup hidden" data-popup="' + postID + '"></div>');
                    $('div.popup[data-popup="' + postID + '"]').append(response[0]).fadeIn(200);
                    $('div.popup[data-popup="' + postID + '"]').removeClass("hidden");
                }

                $('body').addClass('overflow-hidden')
                $('.p-bg').removeClass("hidden");
                $('.p-bg').fadeIn(200);
                ajaxLock = false;
            },

            //Ajax call is not successful, still remove lock in order to try again
            error: function () {

                ajaxLock = false;
            }
        });
    }
    if($('.preload-popup').length && $('.preload-popup').data('post') !== 0 ){
      ajax_lazy_popup($('.preload-popup').data('post'));
    }


    function setQueryStringParameter(name, value) {
      const params = new URLSearchParams(window.location.search);
      params.set(name, value);
      window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
    }

    $('.readmore,.readmore-card').on('click', function(e) {
        e.preventDefault();
        setQueryStringParameter('popup', $(this).data('permalink'));
        if( ! ajaxLock ) {
            if ( $(this).data('post') != '' ) {
                ajax_lazy_popup($(this).data('post'));
            }
        }
    });

    $('.first-level-dropdown').on('click', function () {
        $(this).next('.menu').toggleClass("hidden");
        $(this).children('img').toggleClass("turn");
    })


    $('main').on('click', '.popupHeader img', function() {
        $('.p-bg').fadeOut(200);
        $('.popup').fadeOut(200);
        $('body').removeClass("overflow-hidden");
    });

    $('.readmore-card-url').on('click', function(){
        window.open($(this).data('url'),$(this).data('target'))
    });

    $('.p-bg').on('click', function() {
        $(this).fadeOut(200);
        $('.popup').fadeOut(200);
        $('body').removeClass("overflow-hidden");
        setQueryStringParameter('popup','');
    });

    var total = $('.sliderbox .slide-block').length, // get the number of slides
    rand = Math.floor( Math.random() * total );

    $('.sliderbox').slick({
        dots: true,
        infinite: true,
        speed: 500,
        arrows: true,
        initialSlide: rand,
        rows: 0,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                }
            }
        ]

    });

    function goToAnchor(anchor) {
        var loc = document.location.toString().split('#')[0];
        document.location = loc + '#' + anchor;
        return false;
    }


    $('.nevermind span').on('click', function() {
        $('.nevermind span').removeClass('active');
        $(this).addClass('active');
        $('.nevermind-li').addClass('hide');
        $('.nevermind-li[data-li="'+$(this).data('li')+'"]').removeClass('hide');
        // goToAnchor('nevermind');
    });

    function makeUnselectable(node) {
        if (node.nodeType == 1) {
            node.setAttribute("unselectable", "on");
        }
        var child = node.firstChild;
        while (child) {
            makeUnselectable(child);
            child = child.nextSibling;
        }
    }

    $('.unselectable').each(function() {
        makeUnselectable(this);
    });

    /* --------------------------------------------- */
    /*           MOBILE-BURGER-NAVIGATION            */
    /* --------------------------------------------- */



    function closeMenu() {
        $('.mobile_header_menu_div').toggleClass('open-mobile-header');
        $('.mobile-nav').toggleClass('hidden');
        $('body').toggleClass('overflow-hidden-mobile');
        $('.logotype .logo').toggleClass('hidden');
        $('.hamburger-line').toggleClass('hamburger-animation');
        $('header section').toggleClass('mobile-menu-change-bg');
    }
    // Burger-Navigation ausklappen
    $('.mobile_header_menu_div').on('click', '.hitbox', closeMenu);
    $('.mobile-nav').on('click', 'a', closeMenu);
    function noHover(){
        if ($(window).width() <= 1024) {
            $('.mobile-nav').find('li').removeClass('is-dropdown-submenu-parent');
        }
    }



    /* --------------------------------------------- */
    /*                  AKKORDEON                    */
    /* --------------------------------------------- */

    $('.akkordeon-item').click(function() {

        if ($('.akkordeon-inner',this).hasClass('akkordeon-active')) {
            $('.akkordeon-inner',this).removeClass('akkordeon-active');
            $('.akkordeon-arrow',this).css('transform','rotate(90deg)');
        }

        else {
            if ($('.akkordeon-inner').hasClass('akkordeon-active')){
                $('.akkordeon-inner').removeClass('akkordeon-active');
                $('.akkordeon-arrow').css('transform','rotate(90deg)');
            }

            $('.akkordeon-inner',this).addClass('akkordeon-active');
            $('.akkordeon-arrow',this).css('transform','rotate(270deg)');
        }
    });


    /* --------------------------------------------- */
    /*                    SQUARE                     */
    /* --------------------------------------------- */

    /*Backend: Square Block needs block-class 'square' Section needs class 'squareContainer'*/

    function squareResize(){
        if ($(window).width() >= 1024) {
            var squareWidth = $('.squareContainer').find('.square').width();
            // $('.squareContainer').find('.square').addClass('squareContent');
            $('.squareContainer').find('.section-container').height(squareWidth);
            $('.squareContainer').find('.bg-white').addClass('squareContent');
            $('.squareContainer').find('.bg-grandblue').addClass('squareContent');
            $('.squareContainer').find('.bg-skyblue').addClass('squareContent');
            $('.squareContainer').addClass('squareContent');
        }
        else {
            $('.squareContainer').find('.bg-white').removeClass('squareContent');
        }
    }

    function squareResizeMedium(){
        if ($(window).width() >= 768) {
            var squareWidth = $('.squareContainerMedium').find('.square').width();
            // $('.squareContainer').find('.square').addClass('squareContent');
            $('.squareContainerMedium').find('.section-container').height(squareWidth);
            $('.squareContainerMedium').find('.bg-white').addClass('squareContent');
            $('.squareContainerMedium').find('.bg-grandblue').addClass('squareContent');
            $('.squareContainerMedium').find('.bg-skyblue').addClass('squareContent');
            $('.squareContainerMedium').addClass('squareContent');
        }
        else {
            $('.squareContainerMedium').find('.bg-white').removeClass('squareContent');
        }
    }

    $(document).ready(function(){
        squareResize();
        squareResizeMedium();
        noHover();
        $(window).resize(function(){
            squareResize();
            squareResizeMedium();
        })
    })


    /* --------------------------------------------- */
    /*                   LEISTUNGEN                  */
    /* --------------------------------------------- */

    $(document).ready(function(){
        $('.leistungThema:first-child').addClass("active");
        $('.leistungThema:first-child').next().removeClass("hidden");
        $('.leistungThema:first-child').next().next().removeClass("hidden");
    })

    $('.leistungThema').click(function() {
        $(this).siblings(".leistungInhalt").addClass("hidden");
        $(this).siblings(".leistungAnwalt").addClass("hidden");
        $(this).addClass("active").siblings().removeClass("active");
        $(this).next().removeClass("hidden");
        $(this).next().next().removeClass("hidden");
    });

    /* --------------------------------------------- */
    /*                    ANKER NAV                  */
    /* --------------------------------------------- */

    $('.menu-item').mouseover(() => {
        $('.anchorNav').removeClass("hidden");
    });

    $('.anchorNav').mouseleave(() => {
        $('.anchorNav').addClass("hidden");
    });


    $('.search-menu').on('click', function() {
        $(this).next('.search-menu-active').removeClass('hidden');
    });

  $(document).mouseup(function(e)
  {
    var container = $(".search-menu-active");

    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
      container.addClass('hidden');
    }
  });


    /* Creates Padding for H2 between sections */
    if($('main > h2, main > h3, main > h1').length) {
        $('main > h2, main > h3, main > h1').each(function() {

            if(!$(this).prev('section').find('.cell.borderless').length || $(this).prev('section').find('.cell.borderless > .boximage').length) {
                $(this).css('padding-top', '65px');
            }
        });
    }

    /* Readmore JS for exclusion case: IF longSection class & readmore, move it  to first P */
    if($('.longSection .readmore, .longSection .readmore-url').length){
        $('.longSection .readmore, .longSection .readmore-url').appendTo('.longSection .contains p:first')

        $('.longSection .contains p').css('position', 'relative');
        $('.longSection .contains p:first .readmore, .longSection .contains p:first .readmore-url').css({"bottom":"-30px", "left":"0", "right":"0", "position":"absolute"})
        $('.longSection .contains > .readmore, .longSection .contains > .readmore-url').remove();
    }





    /* eslint-enable */
};
export default main;



// WEBPACK FOOTER //
// ./src/scripts/modules/main.js